export const categories = [
  {
    slug: 'character-analysis',
    name: '人物分析',
    description: '深度解析白洁传中各主要人物的性格特点、命运轨迹与文学意义',
    icon: 'ri-user-search-line',
  },
  {
    slug: 'version-intro',
    name: '版本介绍',
    description: '追溯白洁传不同版本间的差异、流传脉络与文献考据',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'story-background',
    name: '故事背景',
    description: '探寻白洁传创作的时代背景、社会风貌与历史语境',
    icon: 'ri-landscape-line',
  },
  {
    slug: 'cultural-interpretation',
    name: '文化解读',
    description: '从民俗学、社会学角度解读白洁传的文化内涵与当代意义',
    icon: 'ri-lightbulb-line',
  },
  {
    slug: 'original-appreciation',
    name: '原著赏析',
    description: '精选白洁传原著精彩篇章进行文学鉴赏与艺术分析',
    icon: 'ri-quill-pen-line',
  },
];